export default "__VITE_ASSET__1d6abfde__"